import * as React from "react";
import { Award, ShieldCheck, Star, Lock } from "lucide-react";
import { Card } from "@/components/ui/card";
const trustBadges = [{
  id: "reach",
  title: "Nationwide",
  subtitle: "Reach",
  icon: Star
}, {
  id: "closings",
  title: "Secure",
  subtitle: "Closings",
  icon: ShieldCheck
}, {
  id: "cash",
  title: "Direct",
  subtitle: "Cash",
  icon: Award
}, {
  id: "remote",
  title: "Remote",
  subtitle: "Efficiency",
  icon: Lock
}];
export default function TrustAccountability() {
  return <section data-section-id="120192" id="our-professional-standards" className="w-full py-16 md:py-24 dark bg-secondary/10">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-10">
          {trustBadges.map((badge, i) => {
          const Icon = badge.icon;
          return <Card key={badge.id} data-index={i} className="w-36 h-36 sm:w-40 sm:h-40 flex flex-col items-center justify-center p-4 gap-3 shadow-sm hover:shadow-md transition-shadow duration-300 border-border/10 bg-card/40 backdrop-blur-md rounded-md">
                <div className="p-3 rounded-full bg-primary/10 text-primary">
                  <Icon className="w-6 h-6 sm:w-8 sm:h-8" strokeWidth={1.5} />
                </div>
                <div className="flex flex-col items-center gap-0.5">
                  <span className="text-sm sm:text-base font-mono font-semibold text-foreground tracking-tight leading-tight">
                    {badge.title}
                  </span>
                  <span className="text-xs font-sans text-muted-foreground uppercase tracking-widest">
                    {badge.subtitle}
                  </span>
                </div>
              </Card>;
        })}
        </div>
        
        <div className="max-w-2xl mx-auto">
          <p className="text-sm md:text-base font-sans text-muted-foreground leading-relaxed">
            Brentwood Enterprises operates as a streamlined, remote land acquisition firm. We bypass the friction of traditional brokerage, providing landowners with direct cash liquidity and professional closing standards across the entire United States.
          </p>
        </div>
      </div>
    </section>;
}